import {
  DAY_MS,
  hasSeenNotice,
  noticeRegistration,
  noticeStorageKey,
  participantStartOrDay,
  type ParticipantOlympiad,
} from '@entities/olympiad'

/** Завершённые старше этого от личного старта окон не вызывают: без порога на
 *  новом устройстве всплыли бы все старые отмены. */
export const RECENT_FINISHED_NOTICE_DAYS = 14

function startMs(olympiad: ParticipantOlympiad): number | null {
  const iso = participantStartOrDay(olympiad)
  if (!iso) return null
  const ms = new Date(iso).getTime()
  return Number.isNaN(ms) ? null : ms
}

/**
 * Олимпиады, о которых надо сказать участнику, в порядке показа: ещё не
 * виденные отмены и дисквалификации, ближайший личный старт первым.
 * Активные берутся все; завершённые — не старше порога от личного старта
 * (без даты старта давность не определить, такие пропускаем). `dismissed` —
 * ключи, закрытые за сессию: работают и когда localStorage недоступен.
 */
export function pendingNoticeOlympiads(
  active: readonly ParticipantOlympiad[],
  finished: readonly ParticipantOlympiad[],
  nowMs: number,
  dismissed: ReadonlySet<string> = new Set()
): ParticipantOlympiad[] {
  const threshold = nowMs - RECENT_FINISHED_NOTICE_DAYS * DAY_MS
  const recentFinished = finished.filter((o) => {
    const start = startMs(o)
    return start !== null && start >= threshold
  })
  const seen = new Set<number>()
  const result: ParticipantOlympiad[] = []
  for (const olympiad of [...active, ...recentFinished]) {
    if (seen.has(olympiad.id)) continue
    seen.add(olympiad.id)
    const registration = noticeRegistration(olympiad)
    if (!registration) continue
    if (dismissed.has(noticeStorageKey(registration)) || hasSeenNotice(registration)) continue
    result.push(olympiad)
  }
  return result.sort(
    (a, b) => (startMs(a) ?? Number.POSITIVE_INFINITY) - (startMs(b) ?? Number.POSITIVE_INFINITY)
  )
}
